import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { NotaValidator } from 'src/app/utils/nota-validator'
import { UnespCoreMessageService } from 'src/libs/unesp-core'
import { TipoProva } from 'src/app/enums/tipo-prova'

@Component({
  selector: 'inscricoes-input-nota-avaliacao',
  templateUrl: './input-nota-avaliacao.component.html',
  styleUrls: ['./input-nota-avaliacao.component.scss'],
})
export class InputNotaAvaliacaoComponent implements OnInit {
  @Input() disabled: boolean = false
  @Input() notaInicial: number | null = null
  @Input() peso: number = 0
  @Input() descricaoProva?: string

  @Output() confirmarNota: EventEmitter<number> = new EventEmitter<number>()

  nota: number | null = null

  constructor(private readonly unespCoreMessageService: UnespCoreMessageService) {}

  ngOnInit(): void {
    if (this.notaInicial) {
      this.nota = this.notaInicial
    }
  }

  validateNota() {
    if (this.nota || this.nota === 0) {
      let validation = NotaValidator.isNotaValid(this.nota)

      if (validation.valid) {
        this.confirmarNota.emit(this.nota)
        return
      }

      this.unespCoreMessageService.showMessageError(validation.message!)
    }
  }

  getDescricaoTipoProva(): string {
    if (!this.descricaoProva) return ''
    const prova = TipoProva[this.descricaoProva as keyof typeof TipoProva]
    return prova ? prova.nome : ''
  }
}
